export default "__VITE_ASSET__BviL$4MA__"